import { FC } from "react";

import useAttendance, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

const AttendanceLayout: FC<Props> = () => {
  // if (loading) { /* Loading */
  //   return <Loading />;
  // }

  return <Styles></Styles>;
};

const Attendance: FC<ReceivedProps> = () => (
  <AttendanceLayout {...useAttendance()} />
);

export default Attendance;
